const dummyNFTs = [
  {
    id: 1,
    name: 'Cyber Ape #112',
    store: 'Footlocker',
    price: '0.15 ETH',
    image: 'https://i.ibb.co/q3WtTLyK/7748166.jpg',
    tags: ['rare', 'ape'],
    etherscan: 'https://etherscan.io/token/0x1234567890abcdef',
  },
 /* {
    id: 2,
    name: 'HypeBeast Runner',
    store: 'Nike Vault',
    price: '0.22 ETH',
    image: 'https://i.ibb.co/Q75tLB8h/5348934.jpg',
    tags: ['sneaker', 'trending'],
    etherscan: 'https://etherscan.io/token/0xabcdef1234567890',
  },*/
];

export default dummyNFTs;
